"use client";

/**
 * Honeypot field — a decoy input that's invisible to humans but auto-filled by
 * many bots. The real form keeps it empty; if it comes back non-empty the
 * submit is treated as automated (blocked client-side and/or flagged server-
 * side via the `website` field on the auth endpoints).
 *
 * Hidden the bot-resistant way: pushed off-screen (NOT display:none, which some
 * bots skip), removed from the tab order, hidden from a11y, and autocomplete
 * disabled so password managers don't fill it.
 */
export function HoneypotField({
  value,
  onChange,
}: {
  value: string;
  onChange: (v: string) => void;
}) {
  return (
    <div
      aria-hidden="true"
      style={{
        position: "absolute",
        left: "-9999px",
        top: "-9999px",
        width: 1,
        height: 1,
        overflow: "hidden",
        opacity: 0,
        pointerEvents: "none",
      }}
    >
      {/* Tempting name + label that bots target; humans never see it.
          The data-*-ignore attrs tell password managers (1Password, LastPass,
          Bitwarden, Dashlane) to skip it so they can't auto-fill it and wrongly
          flag a real user. `website` isn't a standard browser-autofill category,
          and autoComplete="off" + data-form-type="other" keep Chrome/Safari out. */}
      <label htmlFor="website">Website (leave blank)</label>
      <input
        id="website"
        name="website"
        type="text"
        tabIndex={-1}
        autoComplete="off"
        data-form-type="other"
        data-lpignore="true"
        data-1p-ignore="true"
        data-bwignore="true"
        data-dashlane-ignore="true"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
